module.exports = __webpack_public_path__ + "static/media/male-icon.755c90c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/male-icon.png
// module id = 503
// module chunks = 0